<template>
  <div class="service-support-body-wrap">
    <MultipleFilter
      :options="filterOptions"
      @chacked="mutipleChacked"
      @closeTag="handlecloseTag"
    ></MultipleFilter>
    <div class="service-body-wrap">
      <SimpleFilter
        :keywords="keywords"
        @search="handleSearch"
        @issueTime="handleIssue"
        @viewCount="handleView"
        @handleDefault="handleDefault"
      ></SimpleFilter>
      <div class="spin-wrap" v-if="loading">
        <a-spin :spinning="loading" />
      </div>
      <Empty v-if="isEmpty" class="empty-wrap"></Empty>
      <div class="body" v-if="!isEmpty && !loading">
        <div
          class="service-result-wrap"
          v-for="item in resultInfos"
          :key="item.id"
        >
          <ServiceCard :instance="item"></ServiceCard>
        </div>
      </div>
      <Pagination :total="total" @pageChange="handleChange"></Pagination>
    </div>
  </div>
</template>

<script>
import MultipleFilter from '@/components/MultipleFilter'
import SimpleFilter from '@/components/common/SimpleFilter'
import ServiceCard from './components/SeriviceCard.vue'
import Pagination from '@/components/common/Pagination'
import Empty from '../../components/common/Empty/index'
import { filterOptions } from './configs/config'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { receServerInfo } from '@/api/serverInfo.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      keywords: '', // 检索关键词
      filterOptions,
      resultInfos: [],
      params: {
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      body: {},
      loading: false,
      isEmpty: false
    }
  },
  components: {
    // InputSearch,
    Pagination,
    ServiceCard,
    SimpleFilter,
    MultipleFilter,
    Empty
  },
  computed: {
    ...mapGetters('headerSearch', ['headSearchValueService'])
  },
  watch: {
    headSearchValueService: {
      handler() {
        this.initParams()
        this.initDefaultValue()
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    // 初始化关键词、请求体
    initParams() {
      this.keywords = this.headSearchValueService
      this.body = {
        name: this.headSearchValueService
      }
    },
    // 初始化方法
    async initDefaultValue() {
      try {
        this.loading = true
        const { rows, total } = await receServerInfo(this.params, this.body)
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.isEmpty = row.length === 0
        this.total = total
        this.resultInfos = row
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    mutipleChacked(result) {
      const datas = {}
      Object.keys(result).forEach(key => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value
        } = data
        datas[prop] = value
      })
      // console.log(datas)
      this.body = datas
      this.initDefaultValue()
    },
    // 多选tag处理
    handlecloseTag(result) {
      const datas = {}
      Object.keys(result).forEach(key => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value
        } = data
        datas[prop] = value
      })
      // console.log(datas)
      this.body = datas
      this.initDefaultValue()
    },
    // 内容查询
    handleSearch(e) {
      const params = { name: e }
      this.params = { ...this.params }
      this.body = params
      this.updateTabValue({ key: 'service', value: e })
      // this.initDefaultValue()
    },
    // 发布时间筛选
    handleIssue(e) {
      // console.log(e)
      this.body = {
        ...this.body,
        orderType: { orderByType: e, orderByField: '0' }
      }
      this.initDefaultValue()
    },
    // 浏览量筛选
    handleView(e) {
      this.body = {
        ...this.body,
        orderType: { orderByType: e, orderByField: '1' }
      }
      // console.log(e)
      this.initDefaultValue()
    },
    // 切换页面
    handleChange(e) {
      // console.log(e)
      this.params.pageNum = e
      this.initDefaultValue()
    },
    // 简单筛选恢复默认
    handleDefault() {
      delete this.body.orderType
      this.initDefaultValue()
    }
  },
  destroyed() {
    // 重置vuex中的tab值
    this.updateTabValue({ key: 'service', value: '' })
  }
}
</script>
